var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "embed__content" }, [
    _vm.embedPoster
      ? _c(
          "div",
          {
            staticClass: "embed-cover",
            style: { "background-image": "url(" + _vm.embedPoster + ")" },
            on: {
              click: function($event) {
                _vm.embedAutoPlay = true
              }
            }
          },
          [
            !_vm.embedAutoPlay
              ? _c("i", { staticClass: "fa fa-play-circle" })
              : _vm._e(),
            _vm._v(" "),
            _vm.embedAutoPlay
              ? _c("div", {
                  staticClass: "frame-wrapper",
                  domProps: { innerHTML: _vm._s(_vm.autoplay_embed_content) }
                })
              : _vm._e()
          ]
        )
      : _c("div", { domProps: { innerHTML: _vm._s(_vm.embedContent) } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }